import { bomValidationColumns } from '@/components/rule-validation/utils/columns/bomColumns'
import { VALIDATIONS_OPTIONS } from '@/constants'
import { basicColumns } from '@/components/rule-validation/utils/columns/basicColumns'

export function validationColumns(type) {
  return type === VALIDATIONS_OPTIONS.TEST_CASES.label
    ? basicColumns()
    : bomValidationColumns()
}
